import { React, useEffect, useState } from 'react';
import { Header } from "../0_layout/HeaderFooter";
import { Footer } from "../0_layout/Footer";
import { useLocation, useParams } from 'react-router-dom';
import { Box, Typography, styled, Button } from '@mui/material';
import { CircularProgress } from '@mui/material';

// Styled green spinner
const LightGreenSpinner = styled(CircularProgress)({
  color: '#66bb6a',
  filter: 'drop-shadow(0 0 6px #66bb6a)',
});

const EventPage = () => {
  const { eventType } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

 // const navigate = useNavigate();
  const [, setEvent] = useState([]);
  const event = location.state?.event;


  useEffect(() => {
    setLoading(true); // Start loading
    fetch(`${process.env.REACT_APP_API_URL}/api/type/events?type=${eventType}`)
      .then(res => res.json())
      .then(data => setEvent(data[0]))
      .finally(() => setLoading(false)); // Stop loading after fetch
  }, [eventType]);

  if (loading) return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="300px"
    >
      <LightGreenSpinner size={50} thickness={5} />
      <Typography variant="h6" mt={2}>
        Loading...
      </Typography>
    </Box>
  );


  if (!event) return <div>Event not found.</div>;

  return (
    <>
      <Header />
      <Box sx={{ height: { xs: '120px', sm: '100px', md: '100px' } }} />

      <Box
        sx={{
          paddingTop: { xs: '80px', sm: '90px', md: '100px' }, // OFFSET for fixed header
          paddingX: { xs: 2, md: 4 },
          backgroundColor: '#f9f9f9',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >

        <Typography
          variant="h2"
          sx={{
            fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
            fontSize: { xs: '24px', sm: '28px', md: '32px' }, // Responsive sizes
            fontWeight: 400,
            color: '#2196f3',
            textTransform: 'uppercase',
            textAlign: 'center',
            margin: '0 0 32px 0',
            letterSpacing: '1px',
          }}
        >
          EVENTS SERIES
        </Typography>



        <Box
          sx={{
            paddingX: { xs: 2, md: 4 },
            backgroundColor: '#f9f9f9',
            minHeight: '100vh',
          }}
          dangerouslySetInnerHTML={{ __html: event.longdescription }}
        />
        <Box sx={{ textAlign: 'center', my: 6 }}>
          {event?.joinLink && (
            <a href={event.joinLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <Button
                sx={{
                  backgroundColor: '#28a745',
                  color: 'white',
                  fontWeight: 'bold',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  marginTop: 2,
                  width: '150px',
                  fontSize: '16px',
                  transition: '0.3s ease',
                  '&:hover': {
                    backgroundColor: '#218838',
                    transform: 'translateY(-3px)',
                    boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.2)'
                  }
                }}
              >
                REGISTER
              </Button>
            </a>
          )}
        </Box>


        <Box
          sx={{
            width: '100vw',
            marginLeft: 'calc(-50vw + 50%)',
            backgroundColor: '#f9f9f9',
            padding: 0,
            mt: 4
          }}
        >
          <Footer />
        </Box>

      </Box>
    </>
  );
};

export default EventPage;
